/**
 * bootprompt.js locale configuration
 * locale : Chinese (Taiwan / Republic of China)
 * author : Nick Payne
 */

import { addLocale } from "../bootprompt";

addLocale("zh_TW", {
  OK: "OK",
  CANCEL: "取消",
  CONFIRM: "確認",
});
